export const initialStudentData = {
  readStudentContext: {
    st_a_hs_college_access: 0,
    id: '',
    geo_2020: '',
    applicant_id: '',
    di_code: '',
    job_id: '',
    term: '',
    old_sat_math: '',
    old_sat_cr: '',
    old_sat_writing: '',
    sat_math: '',
    sat_ebrw: '',
    act_english: '',
    act_math: '',
    act_science: '',
    act_reading: '',
    act_writing: '',
    act_composite: '',
    display_score: '',
    score_source: '',
    hs_ceeb_cd: '',
    gender: '',
    a_nh_college_access: '',
    a_nh_crime_ptile: '',
    a_nh_family_ptile: '',
    a_nh_educ_ptile: '',
    a_nh_housing_ptile: '',
    a_nh_medfaminc_ptile: '',
    a_nh_overrall_ptile: '',
    a_nh_overall_decile: '',
    rural: '',
    bie_school: '',
    ddv_apcapstone: '',
    a_hs_satc_25: '',
    a_hs_satc_50: '',
    a_hs_satc_75: '',
    ari_rank: '',
    ncessch: '',
    org_nm: '',
    a_sr_class_size: '',
    a_pct_taking_sat: 0,
    a_avg_coll_sat_hs: '',
    a_avg_frl_pct: '',
    a_hs_crime_ptile: '',
    a_hs_college_access: '',
    a_hs_family_ptile: '',
    a_hs_educ_ptile: '',
    a_hs_housing_ptile: '',
    a_hs_medfaminc_ptile: '',
    a_hs_overrall_ptile: '',
    a_hs_overall_decile: '',
    application_type: '',
    admitted: '',
    enrolled: '',
    waitlist: '',
    first_year_gpa: '',
    sophomore_retention: '',
    need_based_grant: '',
    pell_recipient: '',
    pell_eligible: '',
    race: '',
    entry_term: '',
    first_generation: '',
    adv_avgapscore: '',
    a_pct_taking_ap: '',
    adv_aptestavail: '',
    adv_aptaken: '',
    dashboard_link: '',
    a_overall: '',
    adv_appct: '',
    create_date: '',
    hsgpa: '',
    number_of_ap_exams: '',
    ap_average: '',
    number_of_ib_exams: '',
    ib_average: '',
    a_nh_svi_ptile: '',
    a_nh_share_no_inter: '',
    st_a_nh_college_access: '',
    st_a_nh_crime_ptile: '',
    st_a_nh_educ_ptile: '',
    st_a_nh_family_ptile: '',
    st_a_nh_housing_ptile: '',
    st_a_nh_medfaminc_ptile: '',
    st_a_nh_overrall_ptile: '',
    st_a_hs_crime_ptile: '',
    st_a_hs_college_access_ptile: '',
    st_a_hs_educ_ptile: '',
    st_a_hs_housing_ptile: '',
    st_a_hs_family_ptile: '',
    st_a_hs_medfaminc_ptile: '',
    st_a_hs_overrall_ptile: '',
    st_a_overall: '',
    city: '',
    state: '',
    country: '',
    address1: '',
    address2: '',
    address3: '',
    zip: '',
    custom_1: '',
    custom_2: '',
    custom_3: '',
    po_box: '',
    chartDisplayUnits: '',
    frl_flag: '',
  },
}

export const initialDiData = { readDIQuery: { di_hs_avg: '', di_nh_avg: '' } }
